import { Lightning } from '@lightningjs/sdk'

import { createKey } from './utils'

export default class QwertyKeyboardRow extends Lightning.Component {
  private _rowIndex = 0
  private _keyIndex = 0

  static _template() {
    return {
      w: (w) => w,
      h: 90,
      flex: {
        direction: 'row',
      },
    }
  }

  set rowIndex(v: number) {
    this._rowIndex = v
  }

  get keyIndex() {
    return this._keyIndex
  }

  set keyIndex(v: number) {
    this._keyIndex = v
  }

  get currentKey() {
    return this.childList.getAt(this.keyIndex)
  }

  get totalKeys() {
    return this.childList.length
  }

  set keys(v) {
    this.patch({ children: v.map((k, i) => createKey(k, i, this._rowIndex)) })
  }

  _getFocused() {
    return this.currentKey
  }

  _handleRight() {
    if (this.keyIndex === this.totalKeys - 1) {
      return false
    } else {
      this._keyIndex++
    }
  }

  _handleLeft() {
    if (this.keyIndex === 0) {
      return false
    } else {
      this._keyIndex--
    }
  }
}
